import React from "react";

function NotFound() {
  return (
    <div className="wrapper">
      <h1 className="text-center mt-4">Page Not Found</h1>
    </div>
  );
}

export default NotFound;
